import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

import { Heading3 } from '../common/heading'

export const GridContainer = styled(Box)`
  margin-bottom: ${props => props.theme.global.edgeSize.small};
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    margin: 0px;
    flex-direction: row;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
  }
`

export const SectionHeading = styled(Box)`
  order: 2;
  margin: 0px ${props => props.theme.global.edgeSize.medium};

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    order: 1;
    margin: ${props => props.theme.global.edgeSize.medium};
  }
`

export const Heading = styled(Heading3)`
  font-size: ${props => props.theme.global.text.small.size};
  line-height: ${props => props.theme.global.text.small.height};

  @media screen and (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    font-size: ${props => props.theme.global.text.medium.size};
    line-height: ${props => props.theme.global.text.medium.height};
  }
`

export const End = styled(Box)`
  order: 1;
  padding: 20px;
  background: white;
  width: 100%;
  justify-content: flex-end;
  align-items: end;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    width: auto;
    background: ${props => props.theme.global.colors['light-1']};
    order: 2;
  }
`

export default {
  GridContainer,
  SectionHeading,
  Heading,
  End,
}
